module.exports = __webpack_public_path__ + "img/procreate-53-frame.5d0755d.png";